/**
 * Copyright (c) ACT, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @prettier
 */

const CUSTOM_DIMS = {
  heights: {
    header: 72,
    input: 40,
    tableHeader: 58,
  },
  widths: {},
};

export default CUSTOM_DIMS;
